import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss'],
  // animations: [routerTransition],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InsightsComponent implements OnInit {
  ngOnInit(): void {}
}
